module.exports = "/assets/50b327541138d1038ae4e5ff1c7fcc7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VU.png
// module id = 1939
// module chunks = 0